// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/9.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_Maincard {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size:cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 8rem 2rem;
  height: 90vh;
}

.Home_card {
  width: 100%;
  align-items: center;
  justify-content: center;
  gap:1rem;
}

.homeCard_title {
  margin: 1rem auto;
  background-color: var(--primary_color);
  color: var(--white);
  padding: .32rem .8rem;
  border-radius: 1rem;
}

.Card_parent {
  padding: 2rem;
  gap:2rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background: rgba(255, 255, 255, 0);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(1.8px);
  -webkit-backdrop-filter: blur(1.8px);
  border: 1px solid rgba(255, 255, 255, 0.66);
}

.Card_parent_child {
  gap:1rem ;
  background-color: var(--secondary_color);
  border-radius: 1rem;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;
  padding:1rem 1rem;
  /* padding:0.5rem 1rem; */
  width: 20rem;
  &:hover {
    transform: scale(1.05);
  }
}

 .card_child_left {
  padding: 1rem;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}


@media screen and (max-width: 1300px) {
  .Home_Maincard {
    background-position: right;
  }
}

@media screen and (max-width: 800px) {
  .Card_parent_child {
    width: 80%;
  }
  .Home_Maincard {
    background-position: right;
    padding: 2rem 2rem;

  }
}

/* Responsive styles for smaller screens */
@media screen and (max-width: 600px) {
  .Card_parent {
    width: 100%;
  }
  .Card_parent_child {
    width: 100%;
  }
}
@media screen and (max-width: 400px) {
  .Card_parent{
  padding: 1rem;
  gap:1rem;
  }
  .Card_parent_child {
    gap:1rem ;
  }
  .Home_Maincard{
    padding: 1rem;
  }
  

}

`, "",{"version":3,"sources":["webpack://./src/Pages/Home/Home.css"],"names":[],"mappings":"AAAA;EACE,yDAAkD;EAClD,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,kCAAkC;EAClC,mBAAmB;EACnB,yCAAyC;EACzC,4BAA4B;EAC5B,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,wCAAwC;EACxC,mBAAmB;EACnB,sCAAsC;EACtC,sCAAsC;EACtC,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ;IACE,sBAAsB;EACxB;AACF;;CAEC;EACC,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;;AAGA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,kBAAkB;;EAEpB;AACF;;AAEA,0CAA0C;AAC1C;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;EACA,aAAa;EACb,QAAQ;EACR;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;;;AAGF","sourcesContent":[".Home_Maincard {\n  background-image: url(\"../../Assets/Images/9.png\");\n  background-size:cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  padding: 8rem 2rem;\n  height: 90vh;\n}\n\n.Home_card {\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  gap:1rem;\n}\n\n.homeCard_title {\n  margin: 1rem auto;\n  background-color: var(--primary_color);\n  color: var(--white);\n  padding: .32rem .8rem;\n  border-radius: 1rem;\n}\n\n.Card_parent {\n  padding: 2rem;\n  gap:2rem;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0);\n  border-radius: 16px;\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(1.8px);\n  -webkit-backdrop-filter: blur(1.8px);\n  border: 1px solid rgba(255, 255, 255, 0.66);\n}\n\n.Card_parent_child {\n  gap:1rem ;\n  background-color: var(--secondary_color);\n  border-radius: 1rem;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s ease-in-out;\n  padding:1rem 1rem;\n  /* padding:0.5rem 1rem; */\n  width: 20rem;\n  &:hover {\n    transform: scale(1.05);\n  }\n}\n\n .card_child_left {\n  padding: 1rem;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n\n@media screen and (max-width: 1300px) {\n  .Home_Maincard {\n    background-position: right;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .Card_parent_child {\n    width: 80%;\n  }\n  .Home_Maincard {\n    background-position: right;\n    padding: 2rem 2rem;\n\n  }\n}\n\n/* Responsive styles for smaller screens */\n@media screen and (max-width: 600px) {\n  .Card_parent {\n    width: 100%;\n  }\n  .Card_parent_child {\n    width: 100%;\n  }\n}\n@media screen and (max-width: 400px) {\n  .Card_parent{\n  padding: 1rem;\n  gap:1rem;\n  }\n  .Card_parent_child {\n    gap:1rem ;\n  }\n  .Home_Maincard{\n    padding: 1rem;\n  }\n  \n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
